import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class bookingStore {

    // Properties

    @observable bookings = [];
    @observable adminBookingLoading = false;

    // Initialization

    @action initAdminBooking() {
        this.adminBookingLoading = true;

        return ApiCaller.Booking.apiGetBookings().then((bookingResponses) => {
            if (bookingResponses) {
                this.bookings = bookingResponses;
            } else {
                this.bookings = [];
            }
            
            this.adminBookingLoading = false;
        })
    }
}

export default new bookingStore()